import React, { useState, useEffect, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import { saveAs } from "file-saver";
import moment from "moment";
import HistoryIcon from "@material-ui/icons/History";
import {
  getProfilesByUser,
  updateProfile,
  getProfile,
} from "../../actions/profile";
import ThermalSalesReport from "./ThermalSalesReport";
import ThermalSalesReportIMIN from "./ThermalSalesReportIMIN";
import {
  useMediaQuery,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Paper,
  IconButton,
  Container,
  TextField,
  CircularProgress,
  FormControl,
  makeStyles,
  useTheme,
  createTheme,
  ThemeProvider,
  InputLabel,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  Tooltip,
  Checkbox,
} from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import PropTypes from "prop-types";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import LastPageIcon from "@material-ui/icons/LastPage";
import ClearIcon from "@material-ui/icons/Clear";
import { getAllClients } from "../../actions/clientActions";
import DeleteOutlineRoundedIcon from "@material-ui/icons/DeleteOutlineRounded";
import RemoveRedEyeOutlinedIcon from "@material-ui/icons/RemoveRedEyeOutlined";
import Autocomplete from "@material-ui/lab/Autocomplete";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { AppContext } from "../../Context/AppContext";
import { useLocation } from "react-router-dom";
import usePermissions from "../../utils/permissions";
import { resolveEntityId, sortInvoicesByNumberDesc } from "../../utils/utils";
import * as api from "../../api/index";

import ProgressButton from "react-progress-button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DSRDialog from "./DSRDialog";
import DateFnsUtils from "@date-io/date-fns";
import {
  deleteInvoice,
  getInvoicesByUser,
  getInvoices,
  getMinimalInvoices,
  softdeleteInvoice,
  cancelInvoice,
} from "../../actions/invoiceActions";
import { getUsers } from "../../actions/auth";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import { useSnackbar } from "react-simple-snackbar";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import GetAppIcon from "@material-ui/icons/GetApp";
import CancelIcon from "@material-ui/icons/Cancel";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const useStyles2 = makeStyles((theme) => ({
  table: {
    minWidth: 980,
  },
  tablecell: {
    fontSize: "16px",
  },
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "20px",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  typography: {
    fontSize: "18px",
    fontWeight: 500,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 150,
  },
  pageShell: {
    width: "100%",
  },
  filterCard: {
    width: "100%",
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: 16,
    border: "1px solid rgba(239, 127, 26, 0.18)",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
  },
  filterHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  filterGrid: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    alignItems: "flex-end",
  },
  filterField: {
    flex: "1 1 180px",
    minWidth: 160,
    [theme.breakpoints.down("sm")]: {
      flexBasis: "100%",
      minWidth: "100%",
    },
  },
  summaryRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(2),
  },
  summaryCard: {
    flex: "1 1 180px",
    minWidth: 180,
    padding: theme.spacing(1.25, 1.5),
    borderRadius: 14,
    background: "linear-gradient(135deg, rgba(239,127,26,0.08), rgba(255,255,255,0.96))",
    border: "1px solid rgba(239, 127, 26, 0.14)",
  },
  summaryLabel: {
    fontSize: 12,
    fontWeight: 600,
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  },
  summaryValue: {
    fontSize: 22,
    fontWeight: 700,
    color: "#111827",
    lineHeight: 1.2,
  },
  actionsRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  tableContainer: {
    width: "100%",
    borderRadius: 16,
    border: "1px solid rgba(15, 23, 42, 0.08)",
    overflowX: "auto",
  },
  tableHeadCell: {
    borderBottom: "none",
    textAlign: "center",
    fontWeight: 700,
    whiteSpace: "nowrap",
    backgroundColor: "#fff7ef",
  },
  tableBodyCell: {
    fontSize: 14,
    cursor: "pointer",
    borderBottom: "none",
    padding: "10px 8px",
    textAlign: "center",
    whiteSpace: "nowrap",
  },
  statusButton: {
    minWidth: 88,
    fontWeight: 600,
  },
}));

const tableStyle = {
  width: 160,
  fontSize: 14,
  cursor: "pointer",
  borderBottom: "none",
  padding: "10px 8px",
  textAlign: "center",
  whiteSpace: "nowrap",
};
const headerStyle = {
  borderBottom: "none",
  textAlign: "center",
  fontWeight: 700,
  whiteSpace: "nowrap",
  backgroundColor: "#fff7ef",
};

const colorTheme = createTheme({
  palette: {
    primary: {
      main: "#ef7f1a",
    },
  },
});

const Invoices = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [downloadStatus, setDownloadStatus] = useState(null);
  const user = JSON.parse(localStorage.getItem("profile"));
  const { profiles } = useSelector((state) => state.profiles);
  const { invoices, deletedInvoices } = useSelector((state) => state.invoices);
  const {
    openDSR,
    setOpenDSR,
    dateDSR,
    setDateDSR,
    startDateDSR,
    setStartDateDSR,
    endDateDSR,
    setEndDateDSR,
    showPreviewDSR,
    setShowPreviewDSR,
  } = useContext(AppContext);
  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 25,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [dateRangeTotals, setDateRangeTotals] = useState({
    totalAmount: 0,
    startDate: null,
    endDate: null
  });
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const { users } = useSelector((state) => state.auth);
  const clients = useSelector((state) => state.clients.clients);
  const [loading, setLoading] = useState(false);
  const isLoading = useSelector((state) => state.invoices.isLoading);
  const [printIMINReport, setPrintIMINReport] = useState(false);
  const [invoiceNumberQuery, setInvoiceNumberQuery] = useState("");
  const [debouncedInvoiceNumberQuery, setDebouncedInvoiceNumberQuery] =
    useState("");
  const [selectedQuickFilter, setSelectedQuickFilter] = useState("paymentMode");
  const [selectedUser, setSelectedUser] = useState(null);
  const [party, setParty] = useState(null);
  const [paymentMode, setPaymentMode] = useState("");
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const {
    loading: permissionsLoading,
    canUpdatePage,
    canDeletePage,
    isAdmin,
  } = usePermissions();

  const [canDownloadReports, setcanDownloadReports] = useState(false);
  const [isAdminn, setIsAdminn] = useState(false);
  const [loadingg, setLoadingg] = useState(true);

  const [permissions, setPermissions] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(true);
  const filterSyncStartedRef = React.useRef(false);
  const isAdminUser = isAdmin();
  const classes = useStyles2();

  const buildMinimalInvoiceFilters = () => ({
    startDate: startDate ? moment(startDate).format("YYYY-MM-DD") : null,
    endDate: endDate ? moment(endDate).format("YYYY-MM-DD") : null,
    userId: isAdminUser ? selectedUser?.id || null : null,
    clientId: party?.id || party?.id || null,
    paymentMode: paymentMode || null,
    invoiceNumber: debouncedInvoiceNumberQuery || null,
  });

  const fetchInvoicePage = (nextPage = 1, nextRowsPerPage = rowsPerPage) => {
    dispatch(
      getMinimalInvoices(nextPage, nextRowsPerPage, buildMinimalInvoiceFilters())
    );
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const profile = JSON.parse(localStorage.getItem("profile")) || {};
        if (!profile.token) throw new Error("No token found");
        setIsAdminn(profile?.result?.userType?.includes("admin") || false);

        const { data } = await api.getUserPermissions();
        setcanDownloadReports(data.canDownloadPdfReports || false);
        setLoadingg(false);
      } catch (error) {
        console.error("Error fetching permissions:", error.message);
        setcanDownloadReports(false);
        setLoadingg(false);
      }
    };
    fetchPermissions();
  }, []);

  useEffect(() => {
    setPage(0);
    fetchInvoicePage(1, rowsPerPage);
    // eslint-disable-next-line
  }, [location, dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedInvoiceNumberQuery(invoiceNumberQuery.trim());
    }, 400);

    return () => clearTimeout(timer);
  }, [invoiceNumberQuery]);

  useEffect(() => {
    if (!filterSyncStartedRef.current) {
      filterSyncStartedRef.current = true;
      return;
    }

    setPage(0);
    fetchInvoicePage(1, rowsPerPage);
    // eslint-disable-next-line
  }, [
    startDate,
    endDate,
    selectedUser?.id,
    party?.id,
    paymentMode,
    debouncedInvoiceNumberQuery,
  ]);

  useEffect(() => {
    if (selectedQuickFilter !== "user") {
      setSelectedUser(null);
    }
    if (selectedQuickFilter !== "paymentMode") {
      setPaymentMode("");
    }
    if (selectedQuickFilter !== "invoiceNumber") {
      setInvoiceNumberQuery("");
      setDebouncedInvoiceNumberQuery("");
    }
  }, [selectedQuickFilter]);

  useEffect(() => {
    if (!isAdminUser && selectedQuickFilter === "user") {
      setSelectedQuickFilter("paymentMode");
    }
  }, [isAdminUser, selectedQuickFilter]);

  useEffect(() => {
    if (isAdminUser && selectedQuickFilter !== "user") {
      setSelectedQuickFilter((current) =>
        current === "paymentMode" ? current : "user"
      );
    }
  }, [isAdminUser]);
  useEffect(() => {
    dispatch(getProfile(user?.userProfile?.id));
  }, [location, dispatch]);
  useEffect(() => {
    // Handle paginated response structure
    if (invoices && Array.isArray(invoices)) {
      setRows(sortInvoicesByNumberDesc(invoices));
    } else if (invoices && invoices.data && invoices.pagination) {
      setRows(sortInvoicesByNumberDesc(invoices.data));
      setPagination(invoices.pagination);
      
      if (invoices.dateRange) {
        setDateRangeTotals({
          totalAmount: invoices.dateRange.totalAmount || 0,
          startDate: invoices.dateRange.startDate,
          endDate: invoices.dateRange.endDate
        });
      }
    }

    // eslint-disable-next-line
  }, [invoices]);

  // Sync page state with server pagination (convert 1-based to 0-based)
  useEffect(() => {
    if (pagination.currentPage !== undefined) {
      setPage(pagination.currentPage - 1);
    }
    if (pagination.limit !== undefined) {
      setRowsPerPage(pagination.limit);
    }
  }, [pagination]);

  useEffect(() => {
    dispatch(getUsers());
  }, [location]);
  useEffect(() => {
    dispatch(
      getAllClients()
    );

    // eslint-disable-next-line
  }, [dispatch]);


  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const { data } = await api.getUserPermissions();
        setPermissions(data); // 👈 EXACT response you shared
      } catch (error) {
        console.error(error);
      } finally {
        setPermissionLoading(false);
      }
    };
  
    fetchPermissions();
  }, []);
  

  const toCommas = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleDateChange = (newDate) => {
    setDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleStartDateChange = (newDate) => {
    setStartDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleEndDateChange = (newDate) => {
    setEndDateDSR(newDate);
    setShowPreviewDSR(false);
  };

  const handleMainStartDateChange = (date) => {
    setStartDate(date);
  };

  const handleMainEndDateChange = (date) => {
    setEndDate(date);
  };


  const handleSubmit = () => {
    setShowPreviewDSR(true);
  };

  const handleClose = () => {
    setOpenDSR(false);
    setShowPreviewDSR(false);
  };
  const filteredRows = rows;

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    fetchInvoicePage(newPage + 1, rowsPerPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
    fetchInvoicePage(1, newRowsPerPage);
  };
  const openInvoice = (id) => {
    const invoiceId = resolveEntityId(id);
    if (!invoiceId) {
      console.error("openInvoice: invalid invoice id", id);
      return;
    }
    history.push(`/invoice/${invoiceId}`);
  };
  const editInvoice = (id) => {
    const invoiceId = resolveEntityId(id);
    if (!invoiceId) return;
    history.push(`/edit/invoice/${invoiceId}`);
  };
  // const handlesoftDelete = (id) => {
  //   const invoiceToDelete = rows.find((row) => row.id === id);

  //   if (invoiceToDelete?.paymentMode?.toLowerCase() === "credit") {
  //     alert("Warning: Credit invoices cannot be deleted!");
  //     return;
  //   }

  //   const confirmDelete = window.confirm(
  //     "Are you sure you want to delete this invoice?"
  //   );
  //   if (confirmDelete) {
  //     dispatch(softdeleteInvoice(id, openSnackbar));
  //     openSnackbar("Invoice deleted successfully");
      
  //     // Refresh current page data after successful deletion
  //     const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
  //     const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
  //     dispatch(getMinimalInvoices(page + 1, rowsPerPage, formattedStartDate, formattedEndDate));
  //   }
  // };

  const canDeleteInvoice = () => {
    return permissions?.pages?.some(
      (p) => p.pageName === "Invoice" && p.canDelete
    );
  };

  console.log(permissions)

  // const canDeleteInvoice = () => {
  //   if (!permissions) return false;
  
  //   return permissions.pages?.some(
  //     (p) =>
  //       p.pageName?.toLowerCase() === "invoice" &&
  //       p.canDelete === true
  //   );
  // };
  
  
  const canDeletePermanently = () => {
    return permissions?.deleteRecordsPermanently === true;
  };
  
  // const handleDeleteInvoice = async (id) => {
  //   const invoice = rows.find((r) => r.id === id);
  
  //   if (invoice?.paymentMode?.toLowerCase() === "credit") {
  //     alert("Credit invoices cannot be deleted");
  //     return;
  //   }
  
  //   const confirmDelete = window.confirm(
  //     canDeletePermanently()
  //       ? "This will permanently delete the invoice. Continue?"
  //       : "Are you sure you want to delete this invoice?"
  //   );
  
  //   if (!confirmDelete) return;
  
  //   try {
  //     if (canDeletePermanently()) {
  //       // 🔥 HARD DELETE
  //       await api.permanentInvoiceDelete(id);
  //       openSnackbar("Invoice permanently deleted");
  //     } else {
  //       // 💤 SOFT DELETE
  //       dispatch(softdeleteInvoice(id));
  //       openSnackbar("Invoice deleted");
  //     }
  
  //     // Refresh list
  //     dispatch(getMinimalInvoices(page + 1, rowsPerPage));
  //   } catch (error) {
  //     openSnackbar("Failed to delete invoice");
  //   }
  // };
  
  const handleDeleteInvoice = async (id) => {
  const invoice = rows.find((r) => r.id === id);

  if (invoice?.paymentMode?.toLowerCase() === "credit") {
    alert("Credit invoices cannot be deleted");
    return;
  }

  const confirmDelete = window.confirm(
    canDeletePermanently()
      ? "This will permanently delete the invoice. Continue?"
      : "Are you sure you want to delete this invoice?"
  );

  if (!confirmDelete) return;

  try {
    if (canDeletePermanently()) {
      // 🔥 HARD DELETE
      await api.permanentInvoiceDelete(id);
      openSnackbar("Invoice permanently deleted");
    } else {
      // 💤 SOFT DELETE
      await dispatch(softdeleteInvoice(id));
      openSnackbar("Invoice deleted");
    }

    fetchInvoicePage(page + 1, rowsPerPage);
  } catch (error) {
    console.error(error);
    openSnackbar("Failed to delete invoice");
  }
};


  const createAndDownloadPdf = () => {
    setLoading(true);
    
    // Check if we have any data to export
    const hasData = (startDate && endDate) ? pagination.totalCount > 0 : rows.length > 0;
    
    if (hasData) {
      setDownloadStatus("loading");
      
      // Format dates for server
      const formattedStartDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
      const formattedEndDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
      
      // Prepare request data
      const requestData = {
        profile: user.userProfile,
        logo: profiles.logo,
        fromDate: formattedStartDate,
        toDate: formattedEndDate,
        users,
      };

      // Add current page data for backward compatibility (if no date range)
      if (!formattedStartDate || !formattedEndDate) {
        requestData.filteredRows = filteredRows;
      }

      axios
        .post(`${process.env.REACT_APP_API}/create-report`, requestData)
        .then(() =>
          axios.get(`${process.env.REACT_APP_API}/fetch-report`, {
            responseType: "blob",
          })
        )
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: "application/pdf" });
          const currentDate = new Date();
          
          // Generate filename based on date range
          let filename = `OrderReport${currentDate}`;
          if (formattedStartDate && formattedEndDate) {
            filename = `OrderReport_${formattedStartDate}_to_${formattedEndDate}_${moment(currentDate).format('YYYY-MM-DD')}`;
          }

          saveAs(pdfBlob, `${filename}.pdf`);
          const downloadUrl = `${process.env.REACT_APP_URL}/files/Exported-Reports/report.pdf`;
          window.open(downloadUrl, "_blank");
          setLoading(false);
          setDownloadStatus("success");
          
          // Show success message with date range info
          if (formattedStartDate && formattedEndDate) {
            openSnackbar(`PDF downloaded successfully for date range: ${formattedStartDate} to ${formattedEndDate}`);
          } else {
            openSnackbar("PDF downloaded successfully for all invoices");
          }
        })
        .catch((error) => {
          console.error("Error downloading PDF:", error);
          setLoading(false);
          setDownloadStatus("error");
          openSnackbar("Error downloading PDF. Please try again.");
        });
    } else {
      openSnackbar("No record to Export");
      setLoading(false);
    }
  };

  const createAndDownloadExcel = () => {
    setLoading(true);
    setDownloadStatus("loading");
    
    // Format dates properly for the server
    const formattedFromDate = startDate ? moment(startDate).format('YYYY-MM-DD') : null;
    const formattedToDate = endDate ? moment(endDate).format('YYYY-MM-DD') : null;
    
    // console.log('Sending dates to server:', { formattedFromDate, formattedToDate });
    
    // Show user what date range is being used
    const dateRangeText = formattedFromDate && formattedToDate 
      ? ` for ${formattedFromDate} to ${formattedToDate}`
      : ' (all invoices)';
    
    axios
      .post(`${process.env.REACT_APP_API}/invoices/comprehensive-excel-report`, {
        fromDate: formattedFromDate,
        toDate: formattedToDate,
        users,
      }, {
        responseType: "blob",
      })
      .then((res) => {
        const excelBlob = new Blob([res.data], { 
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
        });
        const currentDate = new Date();
        const fileName = `Comprehensive_Invoice_Report_${moment(currentDate).format("YYYY-MM-DD_HH-mm-ss")}.xlsx`;
        
        saveAs(excelBlob, fileName);
        setLoading(false);
        setDownloadStatus("success");
        openSnackbar(`Excel report downloaded successfully${dateRangeText}`);
      })
      .catch((error) => {
        console.error("Error downloading Excel report:", error);
        setLoading(false);
        setDownloadStatus("error");
        openSnackbar("Error downloading Excel report. Please try again.");
      });
  };
  
  const handleClientNameClick = (id) => {
    history.push(`/stats/${id}`);
  };
  if (!user) {
    history.push("/login");
  }

  const totalAmount = filteredRows.reduce((total, row) => {
    if (typeof row.total === "number") {
      return total + row.total;
    } else {
      return total;
    }
  }, 0);
  const salespersonsProps = {
    options: users || [],
    getOptionLabel: (option) => option.name,
  };

  const hasActiveFilters = Boolean(
    startDate ||
      endDate ||
      selectedUser ||
      paymentMode ||
      debouncedInvoiceNumberQuery
  );

  const handleClearFilters = () => {
    setStartDate(null);
    setEndDate(null);
    setSelectedUser(null);
    setPaymentMode("");
    setInvoiceNumberQuery("");
    setDebouncedInvoiceNumberQuery("");
    setSelectedInvoices([]);
  };

  function checkStatus(status) {
    switch (status) {
      case "Partial":
        return {
          border: "solid 0px #1976d2",
          backgroundColor: "#baddff",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Paid":
        return {
          border: "solid 0px green",
          backgroundColor: "#a5ffcd",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Due":
        return {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      case "Cancelled":
        return {
          border: "solid 0px #ff6b6b",
          backgroundColor: "#ffd8d8",
          padding: "8px 18px",
          borderRadius: "20px",
        };
      default:
        return {
          border: "solid 0px red",
          backgroundColor: "#ffaa91",
          padding: "8px 18px",
          borderRadius: "20px",
        };
    }
  }

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = filteredRows.map((n) => n.id);
      setSelectedInvoices(newSelected);
      return;
    }
    setSelectedInvoices([]);
  };

  const handleSelectInvoice = (id) => {
    const selectedIndex = selectedInvoices.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedInvoices, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedInvoices.slice(1));
    } else if (selectedIndex === selectedInvoices.length - 1) {
      newSelected = newSelected.concat(selectedInvoices.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedInvoices.slice(0, selectedIndex),
        selectedInvoices.slice(selectedIndex + 1)
      );
    }

    setSelectedInvoices(newSelected);
  };

  const handleBulkCancel = () => {
    if (selectedInvoices.length === 0) {
      openSnackbar("Please select invoices to cancel");
      return;
    }

    const confirmCancel = window.confirm(
      `Are you sure you want to cancel ${selectedInvoices.length} selected invoice(s)?`
    );

    if (confirmCancel) {
      const invoicesToCancel = filteredRows.filter(
        (row) => 
          selectedInvoices.includes(row.id) && 
          row.paymentMode?.toLowerCase() !== "credit"
      );

      if (invoicesToCancel.length === 0) {
        openSnackbar("No valid invoices to cancel. Credit invoices cannot be canceled.");
        return;
      }

      // Cancel all selected invoices
      const cancelPromises = invoicesToCancel.map((invoice) => 
        dispatch(cancelInvoice(invoice.id, openSnackbar))
      );
      
      // Wait for all cancellations to complete, then refresh data
      Promise.all(cancelPromises).then(() => {
        setSelectedInvoices([]);
        openSnackbar(`Successfully canceled ${invoicesToCancel.length} invoice(s)`);
        fetchInvoicePage(page + 1, rowsPerPage);
      });
    }
  };

  const handleCancelInvoice = (id) => {
    const invoiceToCancel = rows.find((row) => row.id === id);

    if (invoiceToCancel?.paymentMode?.toLowerCase() === "credit") {
      alert("Warning: Credit invoices cannot be canceled!");
      return;
    }

    const confirmCancel = window.confirm(
      "Are you sure you want to cancel this invoice?"
    );

    if (confirmCancel) {
      dispatch(cancelInvoice(id, openSnackbar));
      openSnackbar("Invoice canceled successfully");
      fetchInvoicePage(page + 1, rowsPerPage);
    }
  };

  // Remove the early return for loading - we'll show the header always

  // Show empty state only when not loading and no data
  const showEmptyState = !isLoading && rows.length === 0;
  const clientsProps = {
    options: clients,
    getOptionLabel: (option) => option.name,
  };

  useEffect(() => {
    setSelectedInvoices([]);
  }, [filteredRows]);

  return (
    <div
      style={{
        minHeight: isMobile ? "740px" : "470px",
        marginLeft: isMobile ? 0 : "5rem",
        width: isMobile ? "100%" : "calc(100% - 5rem)",
        paddingLeft: isMobile ? 0 : "8px",
        boxSizing: "border-box",
      }}
    >
      <ThemeProvider theme={colorTheme}>
        <Container
          style={{
            width: "100%",
            maxWidth: "100%",
            paddingTop: "8px",
            paddingBottom: "8px",
            border: "none",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "10px",
                padding: "12px",
                borderRadius: "14px",
                border: "1px solid rgba(239, 127, 26, 0.18)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
              }}
            >
              <FormControl
                variant="outlined"
                size="small"
                style={{ minWidth: isMobile ? "100%" : "180px" }}
              >
                <InputLabel id="invoice-quick-filter-label">
                  Quick Filter
                </InputLabel>
                <Select
                  labelId="invoice-quick-filter-label"
                  value={selectedQuickFilter}
                  onChange={(event) => setSelectedQuickFilter(event.target.value)}
                  label="Quick Filter"
                >
                  {isAdminUser && <MenuItem value="user">Filter by User</MenuItem>}
                  <MenuItem value="paymentMode">Filter by Payment Mode</MenuItem>
                  <MenuItem value="invoiceNumber">Filter by Invoice Number</MenuItem>
                </Select>
              </FormControl>

              {selectedQuickFilter === "user" && isAdminUser ? (
                <Autocomplete
                  {...salespersonsProps}
                  value={selectedUser}
                  onChange={(_event, value) => setSelectedUser(value)}
                  style={{ minWidth: isMobile ? "100%" : "220px", flex: 1 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Select User"
                      variant="outlined"
                      size="small"
                    />
                  )}
                />
              ) : null}

              {selectedQuickFilter === "paymentMode" ? (
                <FormControl
                  variant="outlined"
                  size="small"
                  style={{ minWidth: isMobile ? "100%" : "190px", flex: 1 }}
                >
                  <InputLabel id="invoice-payment-mode-label">
                    Payment Mode
                  </InputLabel>
                  <Select
                    labelId="invoice-payment-mode-label"
                    value={paymentMode}
                    onChange={(event) => setPaymentMode(event.target.value)}
                    label="Payment Mode"
                  >
                    <MenuItem value="">
                      <em>All</em>
                    </MenuItem>
                    <MenuItem value="Cash">Cash</MenuItem>
                    <MenuItem value="Online">Online</MenuItem>
                    <MenuItem value="Credit">Credit</MenuItem>
                  </Select>
                </FormControl>
              ) : null}

              {selectedQuickFilter === "invoiceNumber" ? (
                <TextField
                  variant="outlined"
                  size="small"
                  label="Invoice Number"
                  value={invoiceNumberQuery}
                  onChange={(event) => setInvoiceNumberQuery(event.target.value)}
                  style={{ minWidth: isMobile ? "100%" : "220px", flex: 1 }}
                />
              ) : null}

              <Button
                variant="outlined"
                color="primary"
                startIcon={<ClearIcon />}
                onClick={handleClearFilters}
                disabled={!hasActiveFilters}
                style={{ height: 40 }}
              >
                Clear
              </Button>

              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  autoOk
                  inputVariant="outlined"
                  label="From"
                  name="FromDate"
                  value={startDate}
                  onChange={handleMainStartDateChange}
                  format="yyyy/MM/dd"
                  style={{ minWidth: isMobile ? "100%" : "190px", flex: 1 }}
                />

                <KeyboardDatePicker
                  autoOk
                  inputVariant="outlined"
                  label="To"
                  name="EndDate"
                  value={endDate}
                  onChange={handleMainEndDateChange}
                  format="yyyy/MM/dd"
                  style={{ minWidth: isMobile ? "100%" : "190px", flex: 1 }}
                />
              </MuiPickersUtilsProvider>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "10px",
                padding: "12px",
                borderRadius: "14px",
                border: "1px solid rgba(239, 127, 26, 0.18)",
                boxShadow: "0 10px 24px rgba(15, 23, 42, 0.06)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                  flex: 1,
                }}
              >
                {loading ? (
                  <CircularProgress style={{ margin: "0 6px" }} size={24} />
                ) : (
                  <>
                  <Button
                    variant="outlined"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadPdf}
                    disabled={loadingg || (!isAdminn && !canDownloadReports)}
                    style={{ height: 40 }}
                  >
                    PDF
                  </Button>
                  
                  <Button
                    variant="outlined"
                    color="secondary"
                    endIcon={<GetAppIcon />}
                    onClick={createAndDownloadExcel}
                    disabled={loadingg || (!isAdminn && !canDownloadReports)}
                    style={{
                      height: 40,
                      cursor:
                        loadingg || (!isAdminn && !canDownloadReports)
                          ? "not-allowed"
                          : "pointer",
                    }}
                    title="Download comprehensive Excel report with all invoice types, summary statistics"
                  >
                    Excel Report
                  </Button>
                  </>
                )}

                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => setOpenDSR(true)}
                  disabled={loadingg || (!isAdminn && !canDownloadReports)}
                  style={{
                    height: 40,
                    cursor:
                      loadingg || (!isAdminn && !canDownloadReports)
                        ? "not-allowed"
                        : "pointer",
                  }}
                >
                  Sales Report
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<HistoryIcon />}
                  onClick={() => history.push("/invoices/deleted")}
                  style={{ height: 40 }}
                >
                  Delete History
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<HistoryIcon />}
                  onClick={() => history.push("/invoices/canceled")}
                  style={{ height: 40 }}
                >
                 Cancel History
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<HistoryIcon />}
                  onClick={() => history.push("/invoices/complimentary")}
                  style={{ height: 40 }}
                >
                  Complimentary History
                </Button>

                {selectedInvoices.length > 0 && (
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<CancelIcon />}
                    onClick={handleBulkCancel}
                    style={{ height: 40 }}
                  >
                    Cancel Selected ({selectedInvoices.length})
                  </Button>
                )}
              </div>

              <div
                style={{
                  marginLeft: isMobile ? 0 : "auto",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: isMobile ? "flex-start" : "flex-end",
                  gap: "10px",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "8px 14px",
                    borderRadius: "999px",
                    background: "rgba(255, 255, 255, 0.92)",
                    border: "1px solid rgba(239, 127, 26, 0.16)",
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#1d3557",
                    whiteSpace: "nowrap",
                  }}
                >
                  Total Invoices: {pagination.totalCount || rows.length}
                </span>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "8px 14px",
                    borderRadius: "999px",
                    background:
                      "linear-gradient(135deg, rgba(255, 248, 230, 0.95), rgba(255, 237, 213, 0.9))",
                    border: "1px solid rgba(239, 127, 26, 0.2)",
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#0f5f2f",
                    whiteSpace: "nowrap",
                  }}
                >
                  Total Amount: {"\u20B9"}
                  {toCommas((dateRangeTotals.totalAmount || 0).toFixed(2))}
                </span>
              </div>

              <DSRDialog
                open={openDSR}
                onClose={handleClose}
                date={dateDSR}
                handleDateChange={handleDateChange}
                startDate={startDateDSR}
                handleStartDateChange={handleStartDateChange}
                endDate={endDateDSR}
                handleEndDateChange={handleEndDateChange}
                handleSubmit={handleSubmit}
                showPreview={showPreviewDSR}
                rows={rows}
                user={user}
                classes={classes}
              />
            </div>
            {/* Date Range Summary - Show when dates are selected */}
            {false && startDate && endDate && (
              <div
                className={classes.textContainer}
              
              >
                
                <Typography variant="h6" className={classes.typography}>
                  Total Invoices: {pagination.totalCount || 0}
                </Typography>
                <Typography variant="h6" className={classes.typography} style={{ color: "#2e7d32", fontWeight: "bold" }}>
                  Total Amount: ₹{toCommas(dateRangeTotals.totalAmount.toFixed(2))}
                </Typography>
               
              </div>
            )}

            {/* Other Filters Summary */}
            {false && (selectedUser || party || paymentMode) && (
              <div
                className={classes.textContainer}
                style={{ margin: isMobile ? "0" : "10px 0 0 2rem" }}
              >
                <Typography variant="h6" className={classes.typography}>
                  Orders Count: {pagination.totalCount || rows.length} 
                  {pagination.totalCount && ` (Page ${pagination.currentPage} of ${pagination.totalPages})`}
                </Typography>

                <Typography variant="h6" className={classes.typography}>
                  Current Page Total: ₹{toCommas(totalAmount.toFixed(2))}
                </Typography>
              </div>
            )}
          </div>

          {/* Show loader in table area when loading */}
          {isLoading ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                paddingTop: "40px",
                paddingBottom: "40px",
                minHeight: "300px",
              }}
            >
              <Spinner />
              <Typography variant="body1" style={{ marginTop: "16px", color: "#666" }}>
                Loading invoices...
              </Typography>
            </div>
          ) : showEmptyState ? (
            /* Show empty state when not loading and no data */
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                paddingTop: "40px",
                paddingBottom: "40px",
                minHeight: "300px",
              }}
            >
              <NoData />
              <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
                No Order yet. Click the plus icon to create Order
              </p>
            </div>
          ) : (
            /* Show table when data is available */
            <TableContainer
              component={Paper}
              elevation={0}
              style={{
                width: "100%",
                borderRadius: "16px",
                border: "1px solid rgba(15, 23, 42, 0.08)",
                overflowX: "auto",
              }}
            >
              <Table
                className={classes.table}
                aria-label="custom pagination table"
              >
                <TableHead>
                  <TableRow>
                  
                    <TableCell style={headerStyle}>Invoice Number</TableCell>
                    <TableCell style={headerStyle}>Date</TableCell>
                    <TableCell style={headerStyle}>Payment Mode</TableCell>
                    <TableCell style={{ ...headerStyle, display: "none" }}>
                      Customer
                    </TableCell>
                    <TableCell style={headerStyle}>Invoice Amount</TableCell>
                    <TableCell style={headerStyle}>Status</TableCell>
                    <TableCell style={headerStyle}>Edit</TableCell>
                    <TableCell style={headerStyle}>Delete</TableCell>
                      <TableCell padding="checkbox" style={headerStyle}>
                      <Checkbox
                        indeterminate={selectedInvoices.length > 0 && selectedInvoices.length < filteredRows.length}
                        checked={filteredRows.length > 0 && selectedInvoices.length === filteredRows.length}
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell style={headerStyle}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        Cancel Invoice
                      </div>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredRows.map((row) => (
                    <TableRow key={row.id} style={{ cursor: "pointer" }}>
                      
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row.id)}
                      >
                        {row.invoiceNumber}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row.id)}
                      >
                        {moment(row.createdAt).format("MMM Do YYYY")}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row.id)}
                      >
                        {row.paymentMode}
                      </TableCell>
                      <TableCell style={{ ...tableStyle, display: "none" }}>
                        {row?.client?.name ? row.client.name : "Cash"}
                      </TableCell>
                      <TableCell
                        style={tableStyle}
                        onClick={() => openInvoice(row.id)}
                      >
                        {row.currency}
                        {row.total ? toCommas(row.total.toFixed(2)) : row.total}
                      </TableCell>
                      <TableCell
                        style={{
                          ...tableStyle,
                          cursor: "pointer",
                        }}
                        onClick={() => openInvoice(row.id)}
                      >
                        <button
                          style={{
                            ...checkStatus(row.status),
                            cursor: "pointer",
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            openInvoice(row.id);
                          }}
                        >
                          {row.status}
                        </button>
                      </TableCell>
                  
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <Tooltip title="Edit Invoice" arrow placement="top">
                          <IconButton
                            onClick={() => editInvoice(row.id)}
                            disabled={
                              permissionsLoading ||
                              (!isAdminUser && !canUpdatePage("Invoice"))
                            }
                            style={{
                              cursor:
                                permissionsLoading ||
                                (!isAdminUser && !canUpdatePage("Invoice"))
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <BorderColorIcon
                              style={{ width: "20px", height: "20px" }}
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <Tooltip title="Delete Invoice" arrow placement="top">
                          {/* <IconButton
                              disabled={
                                permissionsLoading ||
                                (!isAdminUser && !canDeletePage("Invoice"))
                              }
                            // onClick={() => handlesoftDelete(row.id)}
                            onClick={() => handleDeleteInvoice(row.id)}
                            style={{
                              cursor:
                                permissionsLoading ||
                                (!isAdminUser && !canDeletePage("Invoice"))
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <DeleteOutlineRoundedIcon
                              style={{ width: "20px", height: "20px" }}
                            />
                          </IconButton> */}
                          <IconButton
                            disabled={
                              permissionsLoading || !canDeleteInvoice()
                            }
                            onClick={() => handleDeleteInvoice(row.id)}
                            style={{
                              cursor:
                                permissionsLoading || !canDeleteInvoice()
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                          >
                            <DeleteOutlineRoundedIcon />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedInvoices.indexOf(row.id) !== -1}
                          onChange={() => handleSelectInvoice(row.id)}
                          onClick={(e) => e.stopPropagation()}
                        />
                      </TableCell>
                      <TableCell style={{ ...tableStyle, width: "10px" }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <Tooltip title="Cancel Invoice" arrow placement="top">
                            <IconButton
                              disabled={
                                permissionsLoading ||
                                (!isAdminUser && !canDeletePage("Invoice"))
                              }
                              onClick={() => handleCancelInvoice(row.id)}
                              style={{
                                cursor:
                                  permissionsLoading ||
                                  (!isAdminUser && !canDeletePage("Invoice"))
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                            >
                              <CancelIcon style={{ width: "20px", height: "20px" }} />
                            </IconButton>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        50,
                        100,
                        150,
                      ]}
                      colSpan={6}
                      count={pagination.totalCount || rows.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { "aria-label": "rows per page" },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </Container>
      </ThemeProvider>
    </div>
  );
};

export default Invoices;


